import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GraphQlPaginationService } from 'libs/graph-ql/src/lib/interfaces';
import { NgSelectSearch } from 'libs/ng-select/src/lib/helpers';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'table-async-selection',
    template: `
        <div class="form-group">
            <ng-select
                [items]="items"
                [clearable]="clearable"
                [placeholder]="placeholder"
                [formControl]="columnFormControl"
                bindLabel="name"
                bindValue="value"
                appendTo="body"
                [loading]="loading"
                [virtualScroll]="true"
                (scrollToEnd)="onSelectScroll()"
                (search)="onSelectSearch($event)"
                (close)="onSelectClose()"
                (open)="onSelectOpen()"
            >
            </ng-select>
        </div>
    `
})
export class TableAsyncSelection {
    @Input() graphQlService: GraphQlPaginationService;
    @Input() columnFormControl: FormControl;
    @Input() clearable: boolean;
    @Input() placeholder: string;
    items: any = [];
    loading: boolean = false;
    isOpen: boolean = false;

    private ngUnsubscribe$ = new Subject<void>();

    ngOnInit() {
        this.graphQlService.loading$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(loading => (this.loading = loading && this.isOpen));
        this.graphQlService.results$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(results => (this.items = results));
        this.graphQlService.refreshItems(this.columnFormControl.value);
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    onSelectScroll() {
        this.graphQlService.onSelectScroll();
    }

    onSelectSearch(search: NgSelectSearch) {
        this.graphQlService.onSelectSearch(search);
    }

    onSelectOpen() {
        this.isOpen = true;
    }

    onSelectClose() {
        this.isOpen = false;
        this.graphQlService.onSelectClose();
    }
}
